export default __webpack_public_path__ + "static/media/gift.345027d2.svg";